import styled from "styled-components";

export const Section = styled.section`
	padding: 3rem 0;
	background-color: rgba(100, 43, 115, 0.05);
	border-top: 1px solid rgba(100, 43, 115, 0.1);
	border-bottom: 1px solid rgba(100, 43, 115, 0.1);

	.container {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 1rem;
	}
`;

export const StatsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 2rem;

	@media (min-width: 576px) {
		grid-template-columns: repeat(3, 1fr);
	}
`;

export const StatCard = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	gap: 0.5rem;

	.icon {
		color: #642b73;
		margin-bottom: 0.25rem;
	}

	.value {
		font-size: 1.5rem;
		font-weight: 700;
		color: #642b73;
	}

	p {
		font-size: 0.9rem;
		color: #6b7280;
		max-width: 200px;
		line-height: 1.5;
	}
`;
